<template>
  <Toast />

  <DataTable
    ref="dv"
    responsiveLayout="scroll"
    id="id_bitacora"
    dataKey="id_bitacora"
    :value="repostajes"
    :paginator="true"
    :rows="25"
    :loading="loading1"
    :filters="filters"
    showGridlines
    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
    :rowsPerPageOptions="[25, 50, 75, 100, 125]"
    currentPageReportTemplate="Viendo {first} a {last} de {totalRecords} fuleos"
  >
    <template #empty
      ><b>No se encontró ningún fuleo de combustible.</b></template
    >
    <template #loading> Cargando Fuleo de Combustibles... </template>
    <Column
      field="id_fuleo"
      header="Id Fuleo"
      :sortable="true"
      :autoWidth="true"
    ></Column>
    <Column
      field="id_piloto"
      header="Piloto"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column
      field="fecha"
      header="Fecha"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column
      field="orometroi"
      header="Orometro Inicial"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column
      field="orometrof"
      header="Orometro Final"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>

    <Column
      field="nodocumento"
      header="# Documento"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>

    <Column
      field="galonaje"
      header="Galonaje"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column
      field="totaldoc"
      header="Monto"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
    <Column
      field="usuario"
      header="Usuario"
      :sortable="true"
      :autoWidth="true"
      style="white-space: nowrap; text-overflow: ellipsis; overflow: hidden"
    ></Column>
  </DataTable>
</template>

<script>
import { FilterMatchMode } from 'primevue/api';
export default {
  data() {
    return {
      filters: null,
      loading1: true,
      isLoading: false,
      repostajes: null,
    };
  },
  created() {
    this.initFilters();
    this.loadFuleos();
  },

  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
    async loadFuleos() {
      try {
        this.repostajes = await this.$store.dispatch('loadFuleos');
        console.log(this.repostajes);
        this.loading1 = false;
      } catch (error) {
        this.error = error.message || 'algo salió mal';
        this.loading1 = false;
      }
    },
  },
};
</script>
